// extracted by mini-css-extract-plugin
module.exports = {"box":"box-2QDDta3F clearfix"};